import { render, staticRenderFns } from "./BusinessAdd.vue?vue&type=template&id=0c1dd0b9&scoped=true&"
import script from "./BusinessAdd.vue?vue&type=script&lang=js&"
export * from "./BusinessAdd.vue?vue&type=script&lang=js&"
import style0 from "./BusinessAdd.vue?vue&type=style&index=0&id=0c1dd0b9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1dd0b9",
  null
  
)

export default component.exports